import BaseEnv from './lib/baseEnv';

export default class HttpLocal {
  constructor() {
    this.env = new BaseEnv().getEnv();
  }
  localAddressWeb() {
    return new Promise(resolve => {
      if (this.env === 'pro') {
        resolve({
          data: {
            web_o: 'https://haitan.shop',
            web_m: 'https://m.haitan.shop',
            openFile: 'https://m.haitan.shop/html/views/previewAttachment.html?url=',
            openUserInfo: 'https://m.haitan.shop/html/views/appContent.html?type=',
          },
        });
      } else {
        resolve({
          data: {
            web_o: `https://${this.env}.haitan.shop`,
            web_m: `https://${this.env}.m.haitan.shop`,
            openFile: `https://${this.env}.m.haitan.shop/html/views/previewAttachment.html?url=`,
            openUserInfo: `https://${this.env}.m.haitan.shop/html/views/appContent.html?type=`,
          },
        });
      }
    });
  }
  localOssParam() {
    return new Promise(resolve => {
      if (this.env === 'pro') {
        resolve({
          data: {
            oss_bucket: 'manwei01',
            oss_region: 'oss-cn-hangzhou',
          },
        });
      } else {
        resolve({
          data: {
            oss_bucket: 'manwei00',
            oss_region: 'oss-cn-shanghai',
          },
        });
      }
    });
  }
}
